export const fallbackReviews = [
  {
    title: 'ISEE',
    text: 'Non è la prima volta che lo uso, documenti facili da caricare e tutto molto veloce anche nella consegna, consigliatissimo',
    author: 'Raffaella Barelli',
    rating: 5,
    verified: true,
    url: 'https://it.trustpilot.com/review/smartcaf.it',
  },
  {
    title: 'Servizio efficace ed efficiente',
    text: 'Sono anni che mi affido a SmartCAF per la compilazione di documenti ISEE. La gestione è stata efficientissima. Consigliato per chi ha diversi impegni lavorativi e vuole ottimizzare i tempi con la gestione online!',
    author: 'Luigi Catino',
    rating: 5,
    verified: true,
    url: 'https://it.trustpilot.com/review/smartcaf.it',
  },
  {
    title: 'Perfetti',
    text: 'Perfetti! Dopo aver fatto isee con altro caf inaffidabile ch mi ha generato isee difforme, ho risolto tutto con SmartCAF! Grazie',
    author: 'Andrea Mangili',
    rating: 5,
    verified: true,
    url: 'https://it.trustpilot.com/review/smartcaf.it',
  },
]

export const iseeTrustpilotCustomData = fallbackReviews
export const modelloRedCustomData = fallbackReviews

export const naspiTrustpilotCustomdata = [
  {
    title: 'La naspi online? Da smartcaf uno spettacolo, veloci e competenti',
    text: "Mi sono trovato da Dio, ho fatto la richiesta e subito il giorno dopo mi è stata fatta firmare e quello seguente mi è arrivata l'accettazione dall'INPS, spettacolo, non pensavo si potesse richiedere la naspi così in fretta e avere una risposta così veloce. Difficilmente lo farò fisicamente, ma online su smartcaf.",
    author: 'Humberto Fattoretto',
    rating: 5,
    verified: true,
    url: 'https://it.trustpilot.com/review/smartcaf.it',
  },
  {
    title: 'Stop alla frustrazione burocratica!',
    text: 'Servizio fantastico! Sfruttatelo se volete ottenere tutto in modo semplice, veloce, garantito e senza perdere tempo con la burocrazia. Ho delegato a loro una richiesta online per la Naspi [...] e in pochissimo tempo (minuti!) me la hanno inoltrata (gratuitamente, tra l’altro). Il servizio clienti è disponibile subito, gentile e professionale. Mille grazie!',
    author: 'Marco Iuliani',
    rating: 5,
    verified: true,
    url: 'https://it.trustpilot.com/review/smartcaf.it',
  },
  {
    title: 'Servizio rapido ed efficiente',
    text: 'Servizio rapido ed efficiente! Ho richiesto la NASPI tramite SmartCaf.it e sono rimasto davvero soddisfatto. La pratica è stata evasa in tempi rapidissimi, con grande professionalità e semplicità. Il processo è chiaro e intuitivo, e il supporto è stato impeccabile. Consiglio vivamente!',
    author: 'Bernardina',
    rating: 5,
    verified: true,
    url: 'https://it.trustpilot.com/review/smartcaf.it',
  },
]

export const colfbanditCustomData = [
  {
    title: 'Servizio veloce',
    text: 'Ho richiesta la busta paga per un collaboratore domestico. La consegna è stata veloce e precisa.',
    author: 'Stefano',
    rating: 5,
    verified: true,
    url: 'https://it.trustpilot.com/review/smartcaf.it',
  },
  {
    title: 'Mi ero rivolta a un caf fisico...',
    text: 'Mi ero rivolta a un caf fisico della mia città con nessun tipo di riscontro. Fortunatamente con smart caf ho ricevuto subito assistenza e sono riuscita a attivare il contratto per la colf in tempi brevissimi.',
    author: 'Alba',
    rating: 5,
    verified: true,
    url: 'https://it.trustpilot.com/review/smartcaf.it',
  },
  {
    title: 'Elaborazione busta paga…',
    text: 'Elaborazione busta paga collaboratore domestico. Tutto perfetto, facile da richiedere e servizio chiaro senza sorprese.',
    author: 'Cliente Verificato',
    rating: 5,
    verified: true,
    url: 'https://it.trustpilot.com/review/smartcaf.it',
  },
]

export const modelloRedditiCustomData = [
  {
    title: 'Modello Redditi PF per forfettari',
    text: 'Modello Redditi PF per forfettari. Servizio eccellente. Altamente consigliato per chi deve gestire la propria Partita IVA.',
    author: 'Valentina',
    rating: 5,
    verified: true,
    url: 'https://it.trustpilot.com/review/smartcaf.it',
  },
  {
    title: 'Consiglio assolutamente',
    text: 'Consiglio assolutamente. Mi sono rivolta a loro per una dichiarazione redditi partita iva con forte ritardo e hanno risolto tutto in tempo. Gentilissimi ed efficienti. Grazie.',
    author: 'Irene',
    rating: 5,
    verified: true,
    url: 'https://it.trustpilot.com/review/smartcaf.it',
  },
  {
    title: 'Ottima esperienza',
    text: 'Ottima esperienza, modello redditi elaborato e consegnato in 24 ore. Ero preoccupato di non farcela in tempo. Grazie mille!',
    author: '',
    rating: 5,
    verified: true,
    url: 'https://it.trustpilot.com/review/smartcaf.it',
  },
]

export const modello730CustomData = [
  {
    title: 'Servizio eccellente',
    text: 'Servizio eccellente, caricamento documenti fatto in 10 minuti. Avevo inviato un documento errato, mi hanno contattato dopo 5 minuti e abbiamo risolto. Eseguito il tutto in 48 ore ho ricevuto il mio 730 elaborato. Evita code inutili ai CAF fisici.',
    author: 'Ombretta',
    rating: 5,
    verified: true,
    url: 'https://it.trustpilot.com/review/smartcaf.it',
  },
  {
    title: 'Da qualche anno mi affido a SmartCaf…',
    text: "Da qualche anno mi affido a SmartCaf sia per l'ISEE che per il 730 e trovo davvero comodo poter fotografare con lo smartphone tutti i documenti. C'è un controllo accurato da parte degli operatori e il tutto viene lavorato nei tempi giusti.",
    author: 'Angelica Gratton',
    rating: 5,
    verified: true,
    url: 'https://it.trustpilot.com/review/smartcaf.it',
  },
  {
    title: 'Ottima prestazione!',
    text: "Personale molto qualificato, tempi rapidi e chiarezza. Sicuramente un'ottima alternativa ai caf fisici. Mi hanno sistemato il 730 e un ringraziamento speciale va alla responsabile che mi ha seguito passo passo con tutte le delucidazioni. Ottima esperienza!",
    author: 'Angelica Gratton',
    rating: 5,
    verified: true,
    url: 'https://it.trustpilot.com/review/smartcaf.it',
  },
]

export const smartForfettarioCustomData = [
  {
    title: 'Modello Redditi PF per forfettari',
    text: 'Modello Redditi PF per forfettari. Servizio eccellente. Altamente consigliato per chi deve gestire la propria Partita IVA.',
    author: 'Valentina',
    rating: 5,
    verified: true,
    url: 'https://it.trustpilot.com/review/smartcaf.it',
  },
  {
    title: 'Consiglio assolutamente',
    text: 'Consiglio assolutamente. Mi sono rivolta a loro per una dichiarazione redditi partita iva con forte ritardo e hanno risolto tutto in tempo. Gentilissimi ed efficienti. Grazie.',
    author: 'Irene',
    rating: 5,
    verified: true,
    url: 'https://it.trustpilot.com/review/smartcaf.it',
  },
  {
    title: 'Ottima esperienza',
    text: 'Ottima esperienza, modello redditi elaborato e consegnato in 24 ore. Ero preoccupato di non farcela in tempo. Grazie mille!',
    author: '',
    rating: 5,
    verified: true,
    url: 'https://it.trustpilot.com/review/smartcaf.it',
  }
]

const rinnovoERilascioPermessoDiSoggiornoCustomData = [
  {
    title: 'Semplicità ed efficienza',
    text: 'Semplicità ed efficienza direttamente a casa.',
    author: 'Cliente Verificato',
    rating: 5,
    verified: true,
    url: 'https://it.trustpilot.com/review/smartcaf.it',
  },
  {
    title: 'Tutto molto semplice',
    text: 'Tutto molto semplice e comunicazioni eccellenti. Molto facile gestire le richieste online.',
    author: 'Giuliana',
    rating: 5,
    verified: true,
    url: 'https://it.trustpilot.com/review/smartcaf.it',
  },
  {
    title: 'Velocità assoluta',
    text: 'Velocità assoluta, tempo due giorni hai il documento completo. Molto facile la piattaforma per caricare i documenti.',
    author: 'Gianluca Derudas',
    rating: 5,
    verified: true,
    url: 'https://it.trustpilot.com/review/smartcaf.it',
  },
]

const normalizeRouteValue = (value) =>
  String(value || '')
    .toLowerCase()
    .split('?')[0]
    .replace(/_/g, '-')

export const getCustomReviewsForRoute = (routeValue, query = {}) => {
  const normalizedRoute = [
    routeValue,
    query?.id,
    query?.slug,
  ]
    .filter(Boolean)
    .map(normalizeRouteValue)
    .join(' ')

  if (!normalizedRoute) {
    return null
  }

  if (normalizedRoute.includes('colf') || normalizedRoute.includes('badanti')) {
    return colfbanditCustomData
  }
  if (
    normalizedRoute.includes('modello-redditi')
  ) {
    return modelloRedditiCustomData
  }

  if (normalizedRoute.includes('naspi') || normalizedRoute.includes('disoccupazione')) {
    return naspiTrustpilotCustomdata
  }

  if (normalizedRoute.includes('730')) {
    return modello730CustomData
  }

  if (normalizedRoute.includes('isee')) {
    return iseeTrustpilotCustomData
  }
  if (normalizedRoute.includes('forfettario')) {
    return smartForfettarioCustomData
  }
    if (normalizedRoute.includes('permesso-di-soggiorno')) {
    return rinnovoERilascioPermessoDiSoggiornoCustomData
  }

  return null
}